import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'

// OBTENER LOS PERMISOS DE UN USUARIO
export const getPermisos = async(idUser) => {
    const respuesta = await PrivateInterceptor(`IT/Users/Permisos/${idUser}`, 'GET')
    return respuesta;
}

// CAMBIAR LOS PERMISOS DE UN USUARIO
export const changePermisos = async(Permisos) => {
    const respuesta = await PrivateInterceptor(`IT/Permisos/changePermisos`, 'PUT', Permisos)
    return respuesta;
}
